import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-admin-side',
  templateUrl: './admin-side.component.html',
  styleUrls: ['./admin-side.component.css']
})
export class AdminSideComponent implements OnInit {
  color: 'primary' | 'accent' | 'warn' = 'accent';
  constructor(private authService: AuthService, private uservice: UserService) { }

  ngOnInit() {
  }


  ////////////////////////////////////////////////
  async logout() {
    //  await this.uservice.logout().subscribe(data => {
    //     alert(data);      
    //   })
    await this.uservice.logout().toPromise();
    this.authService.logout();
  }
    ///////////////////////////////////////////////

}
